import React, { useContext, useState } from 'react';
import { AuthContext } from './AuthContext';
import Login from 'pages/Login';

const LoginRequired = ( { children } ) => {
  const { isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated) {
    return children;
  } else {
    return <Login />;
  }
};

export default LoginRequired;
